import http from "@/settings/apiSettings"

class CrmActivitatiDataService {
  save(data: any): Promise<any> {
    return http.clientComercialOdata.post("/CRM_Activitati", data);
  }


  async uploadActivityFile(activityId: string, file: File) {
    const fd = new FormData();
    fd.append("file", file);

    return http.clientComercialUpload.post(
      `/crm/activitati/${activityId}/files`,
      fd,
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("ERA_Jwt"),
          // NU seta Content-Type aici!
        },
      }
    );
  }


  list(activityId: string) {
    return http.clientComercialUpload.get(`/crm/activitati/${activityId}/files`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") },
    });
  }

  download(fileId: string) {
    return http.clientComercialUpload.get(`/crm/activitati/files/${fileId}`, {
      responseType: "blob",
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") },
    });
  }

  replace(fileId: string, file: File) {
    const fd = new FormData();
    fd.append("file", file);

    return http.clientComercialUpload.put(`/crm/activitati/files/${fileId}`, fd, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("ERA_Jwt"),
      },
    });
  }

  upload(activityId: string, file: File) {
    const fd = new FormData();
    fd.append("file", file);

    return http.clientComercialUpload.post(`/crm/activitati/${activityId}/files`, fd, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") },
    });
  }



}
export default new CrmActivitatiDataService();